export const studiKWcolumns = [
  'Name',
  'Date',
  'Mobile',
  'Country',
  'Brand',
  'Industry',
  'Status',
  'Progress',
  'Missing Kw',
  'Competitor',
  'Multiple Result',
  'N°Kw',
  'Cost min (est.)',
  'Cost max (est.)',
  'Link',
]

export const studiKWSchedulingColumns = [
  'Nome',
  'Files',
  'Next Run',
  'Mobile',
  'Country',
  'Brand',
  'Industry',
  'Creation',
  'N°Kw',
  'Cost min monthly (est.)',
  'Cost max monthly (est.)',
  'Options',
]

export const month = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const iso3166_1_Alpha3 = [
  "AND",
  "ARE",
  "AFG",
  "ATG",
  "AIA",
  "ALB",
  "ARM",
  "AGO",
  "ATA",
  "ARG",
  "ASM",
  "AUT",
  "AUS",
  "ABW",
  "ALA",
  "AZE",
  "BIH",
  "BRB",
  "BGD",
  "BEL",
  "BFA",
  "BGR",
  "BHR",
  "BDI",
  "BEN",
  "BLM",
  "BMU",
  "BRN",
  "BOL",
  "BES",
  "BRA",
  "BHS",
  "BTN",
  "BVT",
  "BWA",
  "BLR",
  "BLZ",
  "CAN",
  "CCK",
  "COD",
  "CAF",
  "COG",
  "CHE",
  "CIV",
  "COK",
  "CHL",
  "CMR",
  "CHN",
  "COL",
  "CRI",
  "CUB",
  "CPV",
  "CUW",
  "CXR",
  "CYP",
  "CZE",
  "DEU",
  "DJI",
  "DNK",
  "DMA",
  "DOM",
  "DZA",
  "ECU",
  "EST",
  "EGY",
  "ESH",
  "ERI",
  "ESP",
  "ETH",
  "FIN",
  "FJI",
  "FLK",
  "FSM",
  "FRO",
  "FRA",
  "GAB",
  "GBR",
  "GRD",
  "GEO",
  "GUF",
  "GGY",
  "GHA",
  "GIB",
  "GRL",
  "GMB",
  "GIN",
  "GLP",
  "GNQ",
  "GRC",
  "SGS",
  "GTM",
  "GUM",
  "GNB",
  "GUY",
  "HKG",
  "HMD",
  "HND",
  "HRV",
  "HTI",
  "HUN",
  "IDN",
  "IRL",
  "ISR",
  "IMN",
  "IND",
  "IOT",
  "IRQ",
  "IRN",
  "ISL",
  "ITA",
  "JEY",
  "JAM",
  "JOR",
  "JPN",
  "KEN",
  "KGZ",
  "KHM",
  "KIR",
  "COM",
  "KNA",
  "PRK",
  "KOR",
  "KWT",
  "CYM",
  "KAZ",
  "LAO",
  "LBN",
  "LCA",
  "LIE",
  "LKA",
  "LBR",
  "LSO",
  "LTU",
  "LUX",
  "LVA",
  "LBY",
  "MAR",
  "MCO",
  "MDA",
  "MNE",
  "MAF",
  "MDG",
  "MHL",
  "MKD",
  "MLI",
  "MMR",
  "MNG",
  "MAC",
  "MNP",
  "MTQ",
  "MRT",
  "MSR",
  "MLT",
  "MUS",
  "MDV",
  "MWI",
  "MEX",
  "MYS",
  "MOZ",
  "NAM",
  "NCL",
  "NER",
  "NFK",
  "NGA",
  "NIC",
  "NLD",
  "NOR",
  "NPL",
  "NRU",
  "NIU",
  "NZL",
  "OMN",
  "PAN",
  "PER",
  "PYF",
  "PNG",
  "PHL",
  "PAK",
  "POL",
  "SPM",
  "PCN",
  "PRI",
  "PSE",
  "PRT",
  "PLW",
  "PRY",
  "QAT",
  "REU",
  "ROU",
  "SRB",
  "RUS",
  "RWA",
  "SAU",
  "SLB",
  "SYC",
  "SDN",
  "SWE",
  "SGP",
  "SHN",
  "SVN",
  "SJM",
  "SVK",
  "SLE",
  "SMR",
  "SEN",
  "SOM",
  "SUR",
  "SSD",
  "STP",
  "SLV",
  "SXM",
  "SYR",
  "SWZ",
  "TCA",
  "TCD",
  "ATF",
  "TGO",
  "THA",
  "TJK",
  "TKL",
  "TLS",
  "TKM",
  "TUN",
  "TON",
  "TUR",
  "TTO",
  "TUV",
  "TWN",
  "TZA",
  "UKR",
  "UGA",
  "UMI",
  "USA",
  "URY",
  "UZB",
  "VAT",
  "VCT",
  "VEN",
  "VGB",
  "VIR",
  "VNM",
  "VUT",
  "WLF",
  "WSM",
  "YEM",
  "MYT",
  "ZAF",
  "ZMB",
  "ZWE"
]

export const filterGscDimensions = [
  {
    value: "page",
    description: "Filter against the specified URI string."
  },
  {
    value: "country",
    description: "Filter against the specified country, as specified by 3-letter country code (ISO 3166-1 alpha-3)."
  },
  {
    value: "device",
    description: "Filter results against the specified device type. Supported values: DESKTOP, MOBILE, TABLET"
  },
  {
    value: "query",
    description: "Filter against the specified query string."
  },
  {
    value: "searchAppearance",
    description: "Filter against a specific search result feature."
  }
]

export const filterGscOperators = [
  {
    value: "equals",
    description: "Your expression must exactly equal the row value (case-sensitive for page and query dimensions)."
  },
  {
    value: "contains",
    description: "The row value must either contain or equal your expression (non-case-sensitive)."
  },
  {
    value: "notContains",
    description: "The row value must not contain your expression either as a substring or a (non-case-sensitive) complete match."
  },
  {
    value: "notEquals",
    description: "Your expression must not exactly equal the row value (case-sensitive for page and query dimensions)."
  },
  {
    value: "includingRegex",
    description: "An RE2 syntax regular expression that must be matched."
  },
  {
    value: "excludingRegex",
    description: "An RE2 syntax regular expression that must not be matched."
  }
]

export const filterGscHelpers = [
  {
    suggerimento: "Pagine che contengono o non contengono un estensione del file (pdf, php, doc, docx, ...)",
    soluzioni: ["page contains .pdf", "page notContains .xlsx"],
  },
  {
    suggerimento: "Pagine che contengono o non contengono un path nell'URL (/en-en/, /wishlist/, ...)",
    soluzioni: ["page contains /en-en/", "page notContains /wishlist/"],
  },
  {
    suggerimento: "Pagine che contengono o non contengono un determinato carattere (?search, ?sort, ...)",
    soluzioni: ["page contains ?", "page notContains ?"],
  },
  {
    suggerimento: "Pagine che contengono o non contengono un sottodominio (m.allianz.it, ageallianz.allianz.it, ...)",
    soluzioni: ["page contains m.domain.it", "page notContains stores.domain.it"],
  }
]